/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import styled from "@emotion/styled";
import { colors } from "@utils/ui_palette";
import { IModule } from "@pages/AssessmentDetail";
import SentenceModal from "../modal/SentenceModal";

interface IPatterns {
  type: string;
  item: IModule;
  anwserCallback: (item: IModule, type: string) => Promise<void>;
}

function Sentence({ type, item, anwserCallback }: IPatterns) {
  const [modal, setModal] = useState<boolean>(false);
  const handleModal = useCallback(
    (state: boolean) => {
      setModal(state);
    },
    [setModal]
  );

  return (
    <>
      <Container
        key={`report-${type}-${item.id}`}
        onClick={() => handleModal(true)}
      >
        <QuestionGrammr>{item.question}</QuestionGrammr>

        <UserAnwserGrammr>{item.answer_submit}</UserAnwserGrammr>
      </Container>

      {modal && (
        <SentenceModal
          item={item}
          type={type}
          handleModal={handleModal}
          callback={anwserCallback}
        />
      )}
    </>
  );
}

const Container = styled.div`
  flex-basis: 100%;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 12px;
  background-color: ${colors.White};
  border: 1px solid ${colors.Gray30};
  box-shadow: 5px 5px 10px ${colors.Gray30};
  margin-right: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const QuestionGrammr = styled.div`
  line-height: 1.5;
  font-size: 24px;
  font-weight: 700;
`;
const UserAnwserGrammr = styled.div`
  color: ${colors.Primary50};
  font-weight: 700;
  font-size: 20px;
  line-height: 1.5;
`;
export default Sentence;
